import { render } from "./TransactionComplete.vue?vue&type=template&id=e1dc4ac6&scoped=true"
import script from "./TransactionComplete.vue?vue&type=script&lang=js"
export * from "./TransactionComplete.vue?vue&type=script&lang=js"

import "./TransactionComplete.vue?vue&type=style&index=0&id=e1dc4ac6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1dc4ac6"]])

export default __exports__